'use client';

import { ELanguage } from '../Utils/constants.js';

var getOptions = function (data, lang) {
    if (!data)
        return [];
    var options = data.map(function (item) {
        return {
            id: item.id,
            name: lang === ELanguage.EN ? item.nameEn : item.name
        };
    });
    return options;
};

export { getOptions };
//# sourceMappingURL=helper.js.map
